import {
  createTitanFunction,
  updateTitanFunction,
  deleteTitanFunction,
  getTitanStatsFunction,
  type CreateTitanData,
  type UpdateTitanData,
  type DeleteTitanData,
  type GetTitanStatsData,
  type CreateTitanResponse,
  type UpdateTitanResponse,
  type DeleteTitanResponse,
  type TitanStatsResponse,
} from "../firebase/functions";

export class TitanService {
  /**
   * Create a new titan using cloud function
   */
  static async createTitan(data: CreateTitanData): Promise<string> {
    try {
      const result = await createTitanFunction(data);
      const response = result.data as CreateTitanResponse;

      if (response.success) {
        return response.titanId;
      } else {
        throw new Error(response.message || "Failed to create titan");
      }
    } catch (error: any) {
      // Error creating titan - rethrow with proper error message
      throw new Error(error.message || "Failed to create titan");
    }
  }

  /**
   * Update an existing titan using cloud function
   */
  static async updateTitan(data: UpdateTitanData): Promise<void> {
    try {
      const result = await updateTitanFunction(data);
      const response = result.data as UpdateTitanResponse;

      if (!response.success) {
        throw new Error(response.message || "Failed to update titan");
      }
    } catch (error: any) {
      // Error updating titan - rethrow with proper error message
      throw new Error(error.message || "Failed to update titan");
    }
  }

  /**
   * Delete a titan using cloud function
   */
  static async deleteTitan(data: DeleteTitanData): Promise<void> {
    try {
      const result = await deleteTitanFunction(data);
      const response = result.data as DeleteTitanResponse;

      if (!response.success) {
        throw new Error(response.message || "Failed to delete titan");
      }
    } catch (error: any) {
      // Error deleting titan - rethrow with proper error message
      throw new Error(error.message || "Failed to delete titan");
    }
  }

  /**
   * Get titan statistics using cloud function
   */
  static async getTitanStats(
    data: GetTitanStatsData
  ): Promise<TitanStatsResponse["stats"]> {
    try {
      const result = await getTitanStatsFunction(data);
      const response = result.data as TitanStatsResponse;

      return response.stats;
    } catch (error: any) {
      // Error getting titan stats - rethrow with proper error message
      throw new Error(error.message || "Failed to get titan statistics");
    }
  }
}
